import styled, { CreateStyled } from '@emotion/styled'
import { lightTheme } from './light'

export { default as global } from './global'
export { lightTheme as defaultTheme }
export { lightTheme }
export type Theme = typeof lightTheme
export default styled as CreateStyled<Theme>
export * from './dark'
